import { Box, Typography } from "@mui/material";
import { mainTextColor } from "../utility/colorPalette";

export const ManualPage = () => {
  return (
    <>
      <Box sx={{ m: 3, color: mainTextColor }}>
        <Typography variant="h4">アプリの使い方</Typography>
        <div style={{ height: "1rem" }} />
        <Typography variant="h6">アプリ概要</Typography>
        <Typography variant="body2">
          本アプリは、AIチャットボットを相手に「Capitalization」（ポジティブな出来事を他者に共有すること）を体験できるWebアプリです。
          <br />
          日々のポジティブな体験をAIに伝えることで、その喜びや満足感を高める効果が期待されています。{" "}
          <br />
          1日1回、チャットボットとのチャットを行うことが出来ます。
        </Typography>
        <div style={{ height: "1.5rem" }} />

        <Typography variant="h6">操作方法</Typography>
        <Typography variant="body1">①トップページ</Typography>
        <Typography variant="body2">
          トップページの『はじめる』ボタンをタップしてください。
        </Typography>
        <Box
          sx={{
            border: "2px solid #ccc",
            borderRadius: "8px",
            backgroundColor: "#f9f9f9",
            p: 0.5,
            display: "inline-block",
          }}
        >
          <img
            src="/manualImages/img001.jpg"
            style={{ borderRadius: "8px", display: "block" }}
          ></img>
        </Box>
        <Typography variant="body2">
          その後画面の指示に従い、出来事を思い出す作業と、アンケートへの回答を行ってください。
        </Typography>
        <div style={{ height: "1.5rem" }} />
        <Typography variant="body1">②チャットボットとのチャット</Typography>
        <Typography variant="body2">
          チャットボットが、あなたの『ポジティブな出来事』について質問をしてきます。あなたは、先ほど思い出した出来事を話題に、自由にチャットボットとのチャットを行ってください。
        </Typography>
        <Typography variant="body2">
          画面上部に会話の終了ボタンがありますので、好きなタイミングでこちらのボタンからチャットを終えてください。
        </Typography>
        <Box
          sx={{
            border: "2px solid #ccc",
            borderRadius: "8px",
            backgroundColor: "#f9f9f9",
            p: 0.5,
            display: "inline-block",
          }}
        >
          <img
            src="/manualImages/img002.jpg"
            style={{ borderRadius: "8px", display: "block" }}
          ></img>
        </Box>
        <Typography variant="body2">
          必ず、終了ボタンから会話を終了するようにして下さい。
        </Typography>
        <div style={{ height: "1.5rem" }} />
        <Typography variant="body1">③チャット後アンケート</Typography>
        <Typography variant="body2">
          画面の指示に従い、アンケートに回答してください。
        </Typography>
        <div style={{ height: "1.5rem" }} />

        <Typography variant="h6">リマインダ</Typography>
        <Typography variant="body2">
          リマインダを設定しておくことでスマートフォンに通知が届くようになり、実施忘れを防止することが出来ます。
        </Typography>
        <div style={{ height: "0.5rem" }} />
        <Typography variant="body1">設定方法</Typography>
        <Typography variant="body2">
          画面下部『設定』ボタンをタップしてください。
        </Typography>
        <Typography variant="body2">
          リマインダ設定→設定の順にタップしてください。通知の許可を求められた場合は許可するようにしてください。
        </Typography>
        <Box
          sx={{
            border: "2px solid #ccc",
            borderRadius: "8px",
            backgroundColor: "#f9f9f9",
            p: 0.5,
            display: "inline-block",
          }}
        >
          <img
            src="/manualImages/img003.jpg"
            style={{ borderRadius: "8px", display: "block" }}
          ></img>
        </Box>
        <Typography variant="body2">
          リマインダを受信したい時間を設定し、登録ボタンをタップしてください。
        </Typography>
      </Box>
    </>
  );
};
